export const replaceSpecialChar = (string) => (
  string.replace(/&amp;/g, "&").replace(/&lt;/g, "<").replace(/&gt;/g, ">")
)